import { render } from "./VehicleProblemAction.vue?vue&type=template&id=b9d265ba&scoped=true"
import script from "./VehicleProblemAction.vue?vue&type=script&lang=js"
export * from "./VehicleProblemAction.vue?vue&type=script&lang=js"

import "./VehicleProblemAction.vue?vue&type=style&index=0&id=b9d265ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9d265ba"]])

export default __exports__